import { Inject } from '@odinjs/odin';

import { Endpoint, ToastService } from '@philips-emr/hpms-provider-commons';
import providerContext from '@philips-emr/hpms-provider-commons/lib/context/provider-context';
import { ActionAPI, DeckAPI, FetchAPI, FieldAPI, FormAPI, PanelAPI } from '@philips-emr/tws-components';
import { ToastLevel } from '@philips-emr/tws-constants';
import Controller, { OnCancel, OnClick, OnClose, OnMount, OnSelectItem, OnSubmit } from '@philips-emr/tws-core/lib/client';
import { MountEvent, SelectItemEvent, SubmitEvent } from '@philips-emr/tws-core/lib/component/types';
import { FileService, HttpService, MessageService } from '@philips-emr/tws-core/lib/services';
import { HttpMethod } from '@philips-emr/tws-core/lib/services/http-service';

import { FragmentNames } from '../../codegen';
import { NegotiationAttachmentsAliases as Aliases } from '../../codegen/constants/aliases/negotiation-attachments-aliases';
import BaseController from '../BaseController';

import { getNegotiationStatus, NegotiationStatus } from './negotiation-controller';

@Controller({ fragment: FragmentNames.NEGOTIATION_ATTACHMENTS })
class NegotiationAttachmentsController extends BaseController {

  @Inject(Aliases.PANEL_ATTACHMENT_LIST)
  private panelAttachmentsList: PanelAPI;
  @Inject(Aliases.FETCH_ATTACHMENTS)
  private fetchAttachments: FetchAPI;
  @Inject(Aliases.FORM_SEND_ATTACHMENTS)
  private formAttachment: FormAPI;
  @Inject(Aliases.FIELD_FILE_UPLOADER)
  private fieldUpload: FieldAPI;
  @Inject(Aliases.PANEL_ADD_ATTACHMENTS)
  private panelAddAttachments: PanelAPI;

  @OnMount(Aliases.FETCH_ATTACHMENTS)
  onMountFetchAttchaments(event: MountEvent): void {
    const api = event.target as FetchAPI;
    const { nrSeqNegotiation } = this.historyService.getCurrentRouteParams();
    api.setParameters({ nrSeqNegotiation });
    api.forceFetch();
  }

  @OnMount(Aliases.ACTION_ADD_NEW_ATTACHMENTS)
  onMountPanelSend(event: MountEvent): void {
    const api = event.target as ActionAPI;
    const { nrSeqNegotiation } = this.historyService.getCurrentRouteParams();
    const nrSeqProvider = providerContext.getSelectedProvider().nrSeqProvider;

    getNegotiationStatus(nrSeqProvider, nrSeqNegotiation as number).then((response) => {
      if (response.body) {
        const { ieStatus } = response.body;
        api.setEnabled(ieStatus == NegotiationStatus.NEGOTIATING);
      }
      return undefined;
    }).catch(() => ToastService.open({ message: MessageService.translate('provider.error-process-request'), level: ToastLevel.ERROR }));
  }

  @OnSubmit(Aliases.FORM_SEND_ATTACHMENTS)
  onSubmitReject(event: SubmitEvent): void {
    const { nrSeqNegotiation } = this.historyService.getCurrentRouteParams();
    const body = event.record;
    void HttpService.post(Endpoint.POST.INSERT_ATTACHMENT_NEGOTIATION, { nrSeqNegotiation }, { body }).then(() => {
      this.panelAttachmentsList.setVisible(true);
      this.formAttachment.setData({});
      this.formAttachment.setRecord({});
      this.fieldUpload.setState({ showValidations: false });
      this.fetchAttachments.forceFetch();
      this.panelAddAttachments.setVisible(false);
    }).catch(() => ToastService.open({ message: MessageService.translate('provider.error-process-request'), level: ToastLevel.ERROR }));
  }

  @OnSelectItem(Aliases.DECK_ATTACHMENTS)
  onSelectAttachment(event: SelectItemEvent<any>): void {
    const api = event.target as DeckAPI;
    const { nrSeqAttachment, fileName } = event.item;
    const { nrSeqNegotiation } = this.historyService.getCurrentRouteParams();

    FileService.download(Endpoint.GET.NEGOTIATION_ATTACHMENT, fileName, { nrSeqNegotiation, nrSeqAttachment }, HttpMethod.GET).then(() => {
      ToastService.open({ message: MessageService.translate('provider.download-initiated'), level: ToastLevel.SUCCESS });
      api.unselectAll();
    }).catch(() => {
      ToastService.open({ message: MessageService.translate('provider.error-finding-file'), level: ToastLevel.ERROR });
      api.unselectAll();
    });
  }

  @OnCancel(Aliases.FORM_SEND_ATTACHMENTS)
  onCleanForm(): void {
    this.panelAddAttachments.setVisible(false);
  }

  @OnClick(Aliases.ACTION_ADD_NEW_ATTACHMENTS)
  onClickAddHistory(): void {
    this.panelAddAttachments.setVisible(true);
  }

  @OnClose(Aliases.MODAL_ATTACHMENTS)
  onCloseModalHistory(): void {
    this.panelAddAttachments.setVisible(false);
  }

}

export {
  NegotiationAttachmentsController,
};
